<template>
  <div>
    <b-container fluid>
      <b-row>
        <slot name="title"></slot>
      </b-row>
      <b-row>
        <b-col>
          <b-row>
            <product_card_1
                v-for="product in getItems"
                :key="product.id"
                :product="product"
            />
          </b-row>

          <b-row class="pt-3 mt-3">
            <m-pagination-400
                v-if="havePagination"
                :meta="paginationMeta"
                :on-change-page="changePageFunction"
            />
            <slot name="more"></slot>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import product_card_1 from "./ProductCard";

export default {
  name: "ProductsList",
  components: {product_card_1},
  props: ["havePagination", "showNumber"],
  data() {
    return {};
  },
  methods: {
    changePageFunction(page) {
      const filters = {
        key: 'is_digital',
        value: 1
      }
      this.$store.commit('Product/setFilters', filters);
      this.$store.dispatch("Product/setProducts", page);
    },
  },
  computed: {
    ...mapGetters({
      paginationMeta: "Product/getPaginationMeta",
      products: "Product/getProducts",
    }),
    getItems() {
      const items = this.products;

      if (this.showNumber) {
        return items.slice(0, this.showNumber);
      } else {
        return items;
      }
    },
  },
  async mounted() {
    await this.$store.commit("Product/setFilters", {key: "is_digital", value: 1});
    await this.$store.dispatch("Product/setProducts", 1);
  },
};
</script>

<style scoped>
.zIndex {
  z-index: 1000;
}
</style>